import endpoints from 'src/shared/service/endpoint/endpoints.class';
import { IApiResponse } from '@shared/interface/api-response.interface';
import { apiGet } from './common/api';
import { ApiError } from '@shared/error/api.error';
import { IChangelog, IRelease } from '@shared/interface/model.interface';
import { manageApiError } from './common/api.lib';

/*****************************************
 *
 * GET FUNCTIONS
 *
 *****************************************/

// Get changelog
export const apiGetChangelog = (): Promise<IChangelog | undefined> => {
  const endpointClass = endpoints.release.getChangelog;
  return apiGet(endpointClass.getUrl(), {
    publicApi: endpointClass.isPublic(),
  })
    .then((response?: IApiResponse<IChangelog>) => {
      if (response != null && response.returnCode === 'CHANGELOG_GET_OK') {
        return Promise.resolve(response.returnSuccess);
      } else {
        throw new ApiError(response?.returnError ?? '', response?.returnCode);
      }
    })
    .catch((error: ErrorConstructor) =>
      manageApiError(error, 'apiGetChangelog'),
    );
};
